// Pure helpers for spiderfying coincident drop points. No Google Maps / React here —
// the component layer feeds fanPlan() output into google.maps.geometry.spherical.computeOffset.

export function coordKey(lat, lng) {
  return `${Number(lat).toFixed(6)},${Number(lng).toFixed(6)}`;
}

export function groupDropPoints(dropPointList) {
  const byKey = new Map();
  (dropPointList || []).forEach((point, index) => {
    const { lat, lng } = point.position;
    const key = coordKey(lat, lng);
    if (!byKey.has(key)) {
      byKey.set(key, { key, center: { lat, lng }, members: [] });
    }
    byKey.get(key).members.push({ point, index });
  });
  return Array.from(byKey.values());
}

// Web-mercator ground resolution (meters per screen pixel) at a latitude and zoom.
export function metersPerPixel(lat, zoom) {
  return (156543.03392 * Math.cos((lat * Math.PI) / 180)) / Math.pow(2, zoom);
}

// One {heading, dist} per member: evenly spaced around a circle of fixed pixel radius.
export function fanPlan(count, lat, zoom, pixelRadius = 50) {
  const dist = pixelRadius * metersPerPixel(lat, zoom);
  const plan = [];
  for (let i = 0; i < count; i++) {
    plan.push({ heading: (360 * i) / count, dist });
  }
  return plan;
}
